import React, { Component } from "react";

import './call.scss';

export default class Call extends Component {
    render() {
        return (
            <div className="call-container">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="calendly-inline-widget" data-url="https://calendly.com/wizy/15min" ></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/Call/Call.js